import React from 'react'
import Navbar from '../inc/Navbar'
import {Link} from "react-router-dom";

import Projectpage from './Projectpage';

function Project() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
                      <div className='ackrishnagar'>
        <div className="album py-1 ">

          <div className="container mt-3">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">About Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    <Projectpage/>
                            <br/>

    </div>
  )
}

export default Project